import LoadScreen from "./LoadScreen";
export default LoadScreen;
